import React from 'react';
import { Box, MenuItem, Select, Tooltip } from '@mui/material';
import CalculateIcon from '@mui/icons-material/Calculate';
import { useTheme } from '@mui/material/styles';
import { getAvailableCalculations } from '../../../constants/calculations';
import { getControlMenuPaperSx, getControlTokens } from './controlTokens';

function ControlCalculationSelect({
  context = 'filterBar',
  value,
  onChange,
  metricField,
  metricType,
  isQuarterly,
  options,
  width = 120,
  ariaLabel = 'Calculation type',
}) {
  const theme = useTheme();
  const tokens = getControlTokens(theme, context);
  const availableCalculations = options || getAvailableCalculations(
    metricField,
    metricType,
    isQuarterly
  );

  return (
    <Box
      data-control-context={context}
      sx={{
        height: tokens.height,
        minHeight: tokens.height,
        width,
        minWidth: width,
        maxWidth: '100%',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: tokens.surface,
        border: `1px solid ${tokens.borderColor}`,
        borderRadius: `${tokens.radius}px`,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          width: context === 'objectToolbar' ? 28 : 34,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRight: `1px solid ${tokens.dividerColor}`,
          color: tokens.textColor,
          flexShrink: 0,
        }}
      >
        <CalculateIcon sx={{ fontSize: tokens.iconSize }} />
      </Box>
      <Select
        value={value || ''}
        onChange={(event) => onChange?.(event.target.value, event)}
        size="small"
        inputProps={{ 'aria-label': ariaLabel }}
        sx={{
          height: tokens.height,
          minWidth: 0,
          flex: 1,
          fontSize: tokens.fontSize,
          color: tokens.textColor,
          backgroundColor: tokens.surface,
          '& .MuiSelect-select': {
            py: 0,
            pl: 0.75,
            pr: '22px !important',
            display: 'flex',
            alignItems: 'center',
            minHeight: `${tokens.height}px !important`,
          },
          '& .MuiSelect-icon': {
            right: 2,
            fontSize: tokens.iconSize,
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
        }}
        MenuProps={{
          PaperProps: {
            elevation: 2,
            sx: {
              ...getControlMenuPaperSx(theme, context),
              maxHeight: 300,
            },
          },
        }}
      >
        {availableCalculations.map((calc) => (
          <MenuItem
            key={calc.id}
            value={calc.id}
            sx={{
              fontSize: tokens.optionFontSize,
              minHeight: context === 'objectToolbar' ? 24 : 28,
              py: 0.25,
              color: tokens.textColor,
              '&:hover': {
                backgroundColor: tokens.hover,
              },
              '&.Mui-selected': {
                backgroundColor: tokens.selected,
                color: tokens.selectedColor,
                '&:hover': {
                  backgroundColor: tokens.selectedHover,
                },
              },
            }}
          >
            <Tooltip title={calc.tooltip || ''} placement="right" arrow>
              <Box sx={{ width: '100%' }}>{calc.label}</Box>
            </Tooltip>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}

export default ControlCalculationSelect;
